import oesa from './oesa';
import oevb from './oevb';
import oevo from './oevo';
import vgh from './vgh';
import spkIfiliale from './spkIfiliale';
import spkStationaer from './spkStationaer';

export default {
  oesa,
  oevb,
  oevo,
  vgh,
  spkIfiliale,
  spkStationaer,
};
